import api from "@/app/api";
import type { EventProperties } from "@/app/eventlogging/eventCollectorEventLogger";
import { EventCollectorEventLogger } from "@/app/eventlogging/eventCollectorEventLogger";
import userStore from "@/store/modules/userStore";
import {
  EventCollectorShipper,
  NoShipper,
} from "@/app/eventlogging/eventCollectorShipper";
import eventLogger from "@/app/eventlogging/eventLogger";
import { BrowserIdentityManager } from "@/store/modules/browserIdentityManager";

const mainAppEventCaptureStrategy = (event: EventProperties) => {
  event.tenantId = api.tenantId.toString();
  event.tenantGroupId = api.tenantGroupId.toString();
  event.timestamp = Date.now();
  event.userId = userStore.state.user?.id.toString() ?? "";
  event.browserInstanceId =
    BrowserIdentityManager.getInstance().getBrowserInstanceId();
};

const logger = eventLogger;
if (logger instanceof EventCollectorEventLogger) {
  logger.addDecorator(mainAppEventCaptureStrategy);
}

const shipper =
  logger instanceof EventCollectorEventLogger
    ? new EventCollectorShipper("brewman7", logger, [])
    : new NoShipper();

export default shipper;
